export const red = "#C70006";
export const lightBlue = "#0081C8";
export const darkBlue = "#002240";
export const blue = "#012752";
export const white = "#ffffff";
export const black = "#000000";
export const mustard = "#d6c278";
export const focus = "#383DAF";
